/**
 * Warstwa API: TABLICA „WSPARCIE <MODUŁ>” — zgłoszenia na działowym Kanbanie (polecenie właściciela 2026-10-01).
 *
 * Właściciel: „zadania mają być umieszczone na działowym Kanban — który może, jak go nie ma, tworzyć się z zakresu
 * Wsparcie (HR, IT tak jak nazwa modułu) — i tam ma być ich podgląd i statusy do realizacji”.
 *
 * Trasy backendu (TicketsController, polityka klasy TicketAgent):
 *  - `GET api/tickets/tablice` — kafle tablic modułów z włączoną funkcją, liczniki w zakresie wołającego;
 *  - `GET api/tickets/tablica?modul=&zamknieteDni=` — kolumny i karty; 409 `module_feature_disabled`, gdy wyłączona;
 *  - `POST api/tickets/{id}/tablica` / `DELETE api/tickets/{id}/tablica` — przypięcie i zdjęcie jednego zgłoszenia;
 *  - `POST api/tickets/bulk/tablica` `{ ids }` — przypięcie zaznaczonych w kolejce.
 *
 * Karta na tablicy NIE ma własnej treści: wszystko liczy serwer ze zgłoszenia, z tym samym zakresem kolejki i wetem
 * poufności. Ruchy karty (przyjęcie, odpowiedź, zamknięcie, wznowienie) idą istniejącymi czynnościami zgłoszenia.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do wspólnego
 * `apiService` (nazwy unikalne w całej aplikacji — patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Kafle tablic: `[{ id, nazwa, modulKod, modulNazwa, dzialId, dzialNazwa, wlaczona, automatycznie, liczniki, nieprzeczytane }]`. */
        getTabliceWsparcia: () => api.get("/tickets/tablice"),

        /**
         * Jedna tablica modułu: `{ tablica, kolumny, karty, obcieto, zamknieteDni }`.
         * @param {string} modul kod modułu zgłoszeń (np. „itsm”, „hr”)
         * @param {{ zamknieteDni?: number }} [opcje] ile dni wstecz pokazywać zamknięte (domyślnie 14)
         */
        getTablicaWsparcia: (modul, { zamknieteDni = 14 } = {}) =>
            api.get("/tickets/tablica", { params: { modul, zamknieteDni } }),

        /** Przypięcie zgłoszenia: `{ wynik: "przypieto"|"juz_na_tablicy", tablica: { tablicaId, nazwa, etap, modulKod } }`. */
        przypnijZgloszenieDoTablicy: (ticketId) => api.post(`/tickets/${ticketId}/tablica`),

        /** Zdjęcie zgłoszenia z tablicy (404, gdy na niej nie leży). */
        zdejmijZgloszenieZTablicy: (ticketId) => api.delete(`/tickets/${ticketId}/tablica`),

        /** Przypięcie wielu: `{ processed, skipped, powody: [{ id, numer, powod }] }`. */
        przypnijZgloszeniaDoTablicyMasowo: (ids) => api.post("/tickets/bulk/tablica", { ids }),
    };
}
